"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GradientLegend = exports.DataSeriesLegend = void 0;

var _react = _interopRequireDefault(require("react"));

var _DataSeriesHeatmapLegend = _interopRequireDefault(require("./DataSeriesHeatmapLegend.js"));

var _GradientHeatmapLegend = _interopRequireDefault(require("./GradientHeatmapLegend.js"));

var _chartDataPropTypes = require("../../manipulate/chartDataPropTypes.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var DataSeriesLegend = function DataSeriesLegend(_ref) {
  var dataSeries = _ref.dataSeries;
  var legendItems = dataSeries.map(function (series) {
    return {
      key: series.info.name,
      name: series.info.name,
      colour: series.info.colour,
      on: !!series.data.length
    };
  }).reverse();
  return /*#__PURE__*/_react["default"].createElement(_DataSeriesHeatmapLegend["default"], {
    legendItems: legendItems
  });
};

exports.DataSeriesLegend = DataSeriesLegend;
DataSeriesLegend.propTypes = {
  dataSeries: _chartDataPropTypes.dataSeriesPropTypes.isRequired
};

var GradientLegend = function GradientLegend(_ref2) {
  var colourAxis = _ref2.colourAxis;
  var minDownRegulatedValue = Math.min.apply(Math, _toConsumableArray(colourAxis.dataClasses.filter(function (dataClass) {
    return dataClass.from <= 0;
  }).map(function (dataClass) {
    return dataClass.from;
  })));
  var maxDownRegulatedValue = Math.max.apply(Math, _toConsumableArray(colourAxis.dataClasses.filter(function (dataClass) {
    return dataClass.to <= 0;
  }).map(function (dataClass) {
    return dataClass.to;
  })));
  var downRegulatedColours = colourAxis.dataClasses.filter(function (dataClass) {
    return dataClass.from <= 0;
  }).map(function (dataClass) {
    return dataClass.color;
  });
  var minUpRegulatedValue = Math.min.apply(Math, _toConsumableArray(colourAxis.dataClasses.filter(function (dataClass) {
    return dataClass.from >= 0;
  }).map(function (dataClass) {
    return dataClass.from;
  })));
  var maxUpRegulatedValue = Math.max.apply(Math, _toConsumableArray(colourAxis.dataClasses.filter(function (dataClass) {
    return dataClass.to >= 0;
  }).map(function (dataClass) {
    return dataClass.to;
  })));
  var upRegulatedColours = colourAxis.dataClasses.filter(function (dataClass) {
    return dataClass.from >= 0;
  }).map(function (dataClass) {
    return dataClass.color;
  });
  return /*#__PURE__*/_react["default"].createElement(_GradientHeatmapLegend["default"], {
    gradients: [{
      fromValue: minDownRegulatedValue,
      toValue: maxDownRegulatedValue,
      colours: downRegulatedColours
    }, {
      fromValue: minUpRegulatedValue,
      toValue: maxUpRegulatedValue,
      colours: upRegulatedColours
    }],
    unit: colourAxis.unit
  });
};

exports.GradientLegend = GradientLegend;
GradientLegend.propTypes = {
  heatmapConfig: _chartDataPropTypes.heatmapConfigPropTypes.isRequired,
  colourAxis: _chartDataPropTypes.colourAxisPropTypes.isRequired
};